"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Spinner = _interopRequireDefault(require("./Spinner"));
var _Text = _interopRequireDefault(require("./Text"));
const LoadingMessageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Loader__LoadingMessageWrapper",
  componentId: "sc-1x4g19s-0"
})(["width:100%;text-align:center;"]);
const Loader = _ref => {
  let {
    message
  } = _ref;
  if (!message) return /*#__PURE__*/React.createElement(_Spinner.default, null);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Spinner.default, null), /*#__PURE__*/React.createElement(LoadingMessageWrapper, null, /*#__PURE__*/React.createElement(_Text.default, {
    type: "Body",
    intlText: message
  })));
};
Loader.defaultProps = {
  message: undefined
};
var _default = exports.default = Loader;